export default "__VITE_ASSET__DTiPWUMQ__"